import { ColDef } from '@ag-grid-community/core'
import {
  ClearwaterTransaction,
  TransactionValidation,
  Validations,
} from '@helios/common-api'

/**
 *
 */
export function getColumnValidations(params?: {
  data?: unknown
  colDef?: ColDef
}): TransactionValidation[] | undefined {
  const data = params?.data as ClearwaterTransaction | undefined
  const validations: Validations | undefined = data?.validations
  return validations?.[params?.colDef?.field ?? '']
}
